module.exports = __webpack_public_path__ + "static/media/count-tasks.0fb647d6.svg";